<template>
  <div
    class="d-flex justify-center align-center pa-12"
    :style="{
      width: '100%',
      height: '100vh',
      position: 'relative',
    }"
  >
    <hero-background
      style="position: absolute; left: 0; top: 0"
    />
    <v-row
      style="height: 100%"
    >
      <v-col
        cols="10"
        md="8"
        lg="6"
        class="d-flex align-end"
        style="height: 100%"
      >
        <v-img :src="ureideaLogo"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HeroBackground from './HeroBackground.vue';
import UreideaLogo from '../assets/ureidea_logo.svg';
import HeroGo from '../assets/hero_go.svg';
import WhoMakesImg from '../assets/who_makes_the_web_interesting.svg';

export default {
  name: 'HeroHeader',
  components: {
    HeroBackground,
  },
  data() {
    return {
      ureideaLogo: UreideaLogo,
      whoMakesImg: WhoMakesImg,
      heroGo: HeroGo,
    };
  },
};
</script>
